import { useCallback, useEffect, useMemo, useState } from "react";
export function useBodyScrollLock(blockScroll = false) {
    const [scrollStatus, setScrollStatus] = useState(blockScroll);
    useEffect(() => {
        const bodyElement = document.body;
        const htmlElement = document.documentElement;
        const toggleLockClasses = (status) => {
            if (bodyElement) {
                bodyElement.classList.toggle("body-locked", status);
                if (htmlElement && bodyElement.scrollHeight > window.innerHeight) {
                    htmlElement.classList.toggle("scroll-padding", status);
                }
            }
        };
        toggleLockClasses(scrollStatus);
        return () => {
            toggleLockClasses(false);
        };
    }, [scrollStatus]);
    const toggleScroll = useCallback((forceState) => {
        setScrollStatus((prevState) => forceState ?? !prevState);
    }, [setScrollStatus]);
    return useMemo(() => ({
        scrollStatus,
        toggleScroll,
    }), [scrollStatus, toggleScroll]);
}
export default useBodyScrollLock;
//# sourceMappingURL=useBodyScrollLock.js.map